import React, { useMemo } from "react";
import JoditEditor from "jodit-react";

const HtmlEditor = ({
  label,
  name,
  onChange,
  placeholder,
  required,
  error,
  className,
  value,
}) => {
  const editorConfig = useMemo(
    () => ({
      controls: {
        font: {
          list: {
            "Poppins, sans-serif": "Poppins",
            "Arial,Helvetica,sans-serif": "Arial",
            "Georgia,serif": "Georgia",
            "Impact,Charcoal,sans-serif": "Impact",
            "Tahoma,Geneva,sans-serif": "Tahoma",
            "'Times New Roman',Times,serif": "Times New Roman",
            "Verdana,Geneva,sans-serif": "Verdana",
          },
        },
      },
    }),
    []
  );

  return (
    <div className={`flex flex-col w-full ${className}`}>
      {label && (
        <label
          htmlFor={name}
          className="text-gray-700 mb-2 font-regular flex items-center text-sm"
        >
          {label}
          {required && <span className="text-red-500 ml-1">*</span>}
        </label>
      )}
      <div className="w-full">
        <JoditEditor
          className="w-full"
          value={value ?? ""}
          onChange={(newContent) => onChange(name, newContent)}
          placeholder={placeholder}
          config={editorConfig}
        />
      </div>
      <h2 className="mt-4 text-gray-700 mb-2 font-regular flex items-center text-sm">
        Preview:
      </h2>
      <div
        className="border pl-6 p-3 bg-gray-100"
        dangerouslySetInnerHTML={{ __html: value || "" }}
      />
      {error && <p className="text-red-500 text-sm mt-1">{error}</p>}
    </div>
  );
};

export default HtmlEditor;
